"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDaysWithUpt = exports.uptPaycodes = void 0;
const luxon_1 = require("luxon");
exports.uptPaycodes = ['US FC Unpaid Time', 'US Unpaid Time'];
const useDaysWithUpt = ({ timeSegmentDailyAggregation }) => {
    return ((timeSegmentDailyAggregation === null || timeSegmentDailyAggregation === void 0 ? void 0 : timeSegmentDailyAggregation.filter(({ timeSegmentTypeId }) => exports.uptPaycodes.includes(timeSegmentTypeId)).map(({ date }) => luxon_1.DateTime.fromFormat(date, 'M/dd/yyyy'))) || []);
};
exports.useDaysWithUpt = useDaysWithUpt;
